import type { HeroData } from './types';
import type { HeroDirectoryEntry } from './directory-types';

function trait(hero: HeroData, label: string) {
  return hero.traits.find((item) => item.label === label);
}

export function heroToDirectoryEntry(hero: HeroData): HeroDirectoryEntry {
  const category = trait(hero, '职业') || trait(hero, '种族');
  const attribute = trait(hero, '属性');
  const role = trait(hero, '定位');
  return {
    id: hero.id,
    gameId: hero.gameId,
    name: hero.name,
    subtitle: hero.subtitle,
    latin: hero.latin,
    head: hero.card || hero.head,
    ...(hero.updatedAt ? { updatedAt: hero.updatedAt } : {}),
    facets: {
      attribute: attribute?.name || '',
      category: category?.name || '',
      role: role?.name || '',
      stars: String(hero.stars),
    },
    traitIcons: [category, attribute, role]
      .filter((item): item is NonNullable<typeof item> => Boolean(item))
      .map((item) => ({
        label: `${item.label}：${item.name}`,
        src: item.icon,
      })),
  };
}
